import { Box, InputLabel, styled } from '@mui/material';

const ChipBox = styled(Box)({
  display: 'inline-flex',
  alignItems: 'center',
  mr: 1
});

const MultiInputWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'nowrap',
  overflowX: 'auto',
  overflowY: 'hidden',
  alignItems: 'center',
  height: '52px',
  width: '100%',
  gap: theme.spacing(1),
  padding: theme.spacing(0.5, 1),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,

  '&:hover': {
    borderColor: theme.palette.text.primary
  },
  '&:focus-within': {
    borderColor: theme.palette.primary.main,
    boxShadow: `0 0 0 1px ${theme.palette.primary.main}`
  }
}));

const MultiInputLabel = styled(InputLabel)({
  backgroundColor: '#fff',
  paddingInline: '4px'
});

export { ChipBox, MultiInputWrapper, MultiInputLabel };
